import { BusinessUnitInterface } from '../interfaces'
import { LocationDto } from '../interfaces/Dto/LocationDto'

// Resuelve la ciudad (LocationDto) de una Business Unit cruzando
// bu.location.locationCode con el catálogo de ciudades. Centraliza la lógica
// que estaba inline en ConsigneeFormV2 (updateBusinessUnitSearch) para que
// OriginForm no cree una 4ª copia.
export const resolveCityFromBusinessUnit = (
  bu: BusinessUnitInterface | undefined,
  cities: LocationDto[]
): LocationDto | undefined => {
  const locationCode = bu?.location?.locationCode
  if (!locationCode) return undefined
  return cities.find((c) => c.locationCode === locationCode)
}
